// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"259":"paywall-settings","357":"viewsVods","665":"viewsSimulcasts","824":"viewsLivestreams"}[chunkId] || chunkId) + "." + {"170":"0a05877f","259":"2463f5e4","353":"abcc6af5","357":"fe8ca4ca","637":"520785ef","656":"722102ac","665":"87044754","824":"73c3714c","927":"bd9181fc"}[chunkId] + ".js";
};